module.exports = __webpack_public_path__ + "img/yellow-rectangle-table-6.865bcdcf.png";